module.exports = __webpack_public_path__ + "img/smart_agro.a5c2ec61.svg";